import {FC} from "react"

import {linkStyles} from "@frontend/components/ui"
import {useBooleanState} from "@frontend/utils/useBooleanState"
import {css, cx} from "@styled-system/css"

import {ConsentModal} from "./consent-modal"

export const AIDisclaimer: FC = () => {
  const {
    state: showModal,
    setTrue: openModal,
    setFalse: closeModal,
  } = useBooleanState(false)

  return (
    <>
      <p
        className={css({
          textStyle: "caption",
          color: "text.tertiary",
          margin: 0,
          textAlign: "center",
          paddingX: 12,
          paddingY: 6,
        })}
      >
        {"AI-generated suggestions. "}
        <button
          onClick={openModal}
          className={cx(
            linkStyles({variant: "inline"}),
            css({textStyle: "caption"}),
          )}
        >
          {"Learn more"}
        </button>
      </p>

      <ConsentModal show={showModal} onClose={closeModal} />
    </>
  )
}
